<template>
	<div class="purchases">
		<v-layout row wrap>
			<v-flex xs12 sm12 md9 class="div-container-purchases">
				<v-layout row wrap>
					<v-flex xs12 sm12 md12>
						<div class="div-container-selects">
							<div class="div-container-filters">
								<date-range-picker :startDate="startDate" :endDate="endDate" presets="Mmty"
									@select="date_range_select"></date-range-picker>
								<select-plus label="Anunciantes" noDataText="Nenhum anunciante" itemName="anunciante"
									:items="advertiserList" v-model="selectedAdvertisers" itemText="reg_name"
									returnObject />
								<select-plus :items="statusDict" item-text="name" v-model="selectedStatus"
									label="Estado" noDataText="Nenhum estado" itemName="estado"
									returnObject></select-plus>
							</div>
							<div class="div-container-filters-button">
								<button :disabled="!!dataLoading" v-on:click="refresh" class="button-generate-note">
									<v-icon class="material-icons-outlined" size="40">bolt</v-icon>
									<p>Gerar relatório</p>
								</button>
							</div>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap v-if="!purchaseTotalLoading">
					<v-flex xs12 sm6 md6>
						<div class=div-container-card-purchases-one>
							<p class="paragrafo-title">Comissões aprovadas</p>
							<p class="paragrafo-subtitle">Valor de comissão aprovada</p>
							<p class="paragrafo-value">{{ to_reais(totalByStatus.approved) }}</p>
						</div>
					</v-flex>
					<v-flex xs12 sm6 md6>
						<div class=div-container-card-purchases-two>
							<p class="paragrafo-title">Comissões pendentes</p>
							<p class="paragrafo-subtitle">Valor de comissão pendente</p>
							<p class="paragrafo-value">{{ to_reais(totalByStatus.issued) }}</p>
						</div>
					</v-flex>
					<v-flex xs12 sm6 md6>
						<div class=div-container-card-purchases-three>
							<p class="paragrafo-title">Comissões canceladas</p>
							<p class="paragrafo-subtitle">Valor de comissão cancelada</p>
							<p class="paragrafo-value">{{ to_reais(totalByStatus.cancelled) }}</p>
						</div>
					</v-flex>
					<v-flex xs12 sm6 md6>
						<div class=div-container-card-purchases-four>
							<p class="paragrafo-title">Comissões estornadas</p>
							<p class="paragrafo-subtitle">Valor de comissão estornada</p>
							<p class="paragrafo-value">{{ to_reais(totalByStatus.reversals) }}</p>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap v-else>
					<v-flex xs12 sm12 md12 class="div-loading-circle">
						<v-progress-circular indeterminate></v-progress-circular>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex sm8 md3 class="div-component-header-purchases">
				<Header class="hidden-xs-and-down" />
			</v-flex>
			<v-flex xs12 sm12 md9>
				<div class="div-container-dataTable-purchases">
					<v-data-table :headers="purchasesHeaders" :items="purchasesItems" :total-items="totalPurchases"
						class="elevation-10" rows-per-page-text="Itens por página" :rows-per-page-items="[10, 100, 500]"
						no-data-text="Sem conversões a exibir" :custom-sort="custom_sort" :loading="dataLoading"
						:pagination.sync="pagination">
						>
						<v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
						<template slot="items" slot-scope="props">
							<td class="font-weight-black">{{ props.item.dtstring }}</td>
							<td class="text-xs-left">{{ props.item.advertiser_name }}</td>
							<td class="text-xs-left">{{ props.item.campaign_name }}</td>
							<td class="font-weight-black text-xs-left">
								<span v-if="props.item.status_string == 'Aprovado'" style="color: #40DA99 !important">
									{{ props.item.value_string }}
								</span>
								<span v-else-if="props.item.status_string == 'Pendente'"
									style="color: #5191F2 !important">
									{{ props.item.value_string }}
								</span>
								<span v-else-if="props.item.status_string == 'Cancelado'"
									style="color: #EA4D4D !important">
									{{ props.item.value_string }}
								</span>
								<span v-else-if="props.item.status_string == 'Estornado'"
									style="color: #F6851D !important">
									{{ props.item.value_string }}
								</span>
								<span v-else class="purple--text">
									{{ props.item.value_string }}
								</span>
							</td>
							<td class="font-weight-black text-xs-left">
								<span v-if="props.item.status_string == 'Aprovado'" style="color: #40DA99 !important">
									{{ props.item.affiliate_commission_string }}
								</span>
								<span v-else-if="props.item.status_string == 'Pendente'"
									style="color: #5191F2 !important">
									{{ props.item.affiliate_commission_string }}
								</span>
								<span v-else-if="props.item.status_string == 'Cancelado'"
									style="color: #EA4D4D !important">
									{{ props.item.affiliate_commission_string }}
								</span>
								<span v-else-if="props.item.status_string == 'Estornado'"
									style="color: #F6851D !important">
									{{ props.item.affiliate_commission_string }}
								</span>
								<span v-else class="purple--text">
									{{ props.item.affiliate_commission_string }}
								</span>
							</td>
							<td class="font-weight-black text-xs-left">
								<span v-if="props.item.status_string == 'Aprovado'" style="color: #40DA99 !important">
									{{ props.item.status_string }}
								</span>
								<span v-else-if="props.item.status_string == 'Pendente'"
									style="color: #5191F2 !important">
									{{ props.item.status_string }}
								</span>
								<span v-else-if="props.item.status_string == 'Cancelado'"
									style="color: #EA4D4D !important">
									{{ props.item.status_string }}
								</span>
								<span v-else-if="props.item.status_string == 'Estornado'"
									style="color: #F6851D !important">
									{{ props.item.status_string }}
								</span>
								<span v-else class="purple--text">
									{{ props.item.status_string }}
								</span>
							</td>
							<td class="text-xs-left">{{ props.item.ref_order }}</td>
							<td class="text-xs-left" v-if="includeMgfKeys">
								{{ props.item.mgf_keys }}
							</td>
						</template>
					</v-data-table>
				</div>
			</v-flex>
			<v-flex xs12>
				<csv-export-button v-show="purchasesItems.length > 0" :attr_names="csvAttrNames"
					:column_names="csvColumnNames" :data="downloadableData" :filename="csvFileName"></csv-export-button>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>

import Header from '../components/Header.vue'
import DateRangePicker from 'magafilio-vue/components/DateRangePicker'
import CsvExportButton from 'magafilio-vue/components/CsvExportButton'
import SelectPlus from 'magafilio-vue/components/SelectPlus'
import { affiliate_api } from '@/api'
import dayjs from 'dayjs'

export default {
	name: 'Purchases',
	mixins: [affiliate_api],
	components: {
		Header,
		DateRangePicker,
		SelectPlus,
		CsvExportButton
	},
	data() {
		return {
			dataLoading: false,
			canRefresh: false,
			purchaseTotalLoading: false,
			totalPurchases: 0,
			purchasesItems: [],
			selectedAdvertisers: [],
			selectedStatus: [],
			statusDict: [
				{ id: 'issued', name: 'Pendente' },
				{ id: 'approved', name: 'Aprovado' },
				{ id: 'cancelled', name: 'Cancelado' },
				{ id: 'denied', name: 'Estornado' },
			],
			csvAttrNames: [
				'dtstring',
				'advertiser_name',
				'campaign_name',
				'value_string',
				'affiliate_commission_string',
				'status_string',
				'ref_order',
				'mgf_keys',
			],
			csvColumnNames: [
				'Data/hora',
				'Anunciante',
				'Campanha',
				'Valor',
				'Comissao',
				'Estado',
				'Ref. Magazord',
				'Chaves MGF',
			],
			pagination: {
				sortBy: 'datetime',
				descending: true,
			},
			totalByStatus: {
				issued: 0,
				approved: 0,
				cancelled: 0,
				denied: 0,
				denied_cancelled: 0,
				reversals: 0,
			},
			startDate: dayjs().startOf('day'),
			endDate: dayjs().endOf('day'),
		}
	},
	computed: {
		affiliate: function () {
			return (this.$root.affiliate && Object.keys(this.$root.affiliate).length > 0)
				? this.$root.affiliate
				: {}
		},
		advertiserList: function () {
			let advertiserList = this.$root.advertiserList
			if (!Array.isArray(advertiserList) || !advertiserList.length) return []
			return advertiserList
		},
		downloadableData: function () {
			return this.fetch_all_purchases
		},
		csvFileName: function () {
			return (
				'magafilio_conversoes_' +
				this.startDate.format('YYYYMMDDHHmmss') +
				'_' +
				this.endDate.format('YYYYMMDDHHmmss')
			)
		},
		purchasesHeaders: function () {
			if (this.includeMgfKeys) {
				return [
					{ text: 'Data/hora', align: 'left', value: 'datetime', width: '13%' },
					{
						text: 'Anunciante',
						value: 'advertiser.register.reg_name',
						width: '15%',
					},
					{ text: 'Campanha', value: 'campaign.reg_name', width: '15%' },
					{ text: 'Valor', value: 'value', width: '15%' },
					{ text: 'Comissão', value: 'affiliate_commission', width: '10%' },
					{ text: 'Estado', value: 'status', width: '10%' },
					{ text: 'Ref.', value: 'ref_order', width: '10%' },
					{ text: 'Chaves MGF', value: 'mgf_keys', width: '10%' },
				]
			} else {
				return [
					{ text: 'Data/hora', align: 'left', value: 'datetime', width: '13%' },
					{ text: 'Anunciante', value: 'advertiser.register.reg_name', width: '20%' },
					{ text: 'Campanha', value: 'campaign.reg_name', width: '20%' },
					{ text: 'Valor', value: 'value', width: '17%' },
					{ text: 'Comissão', value: 'affiliate_commission', width: '10%' },
					{ text: 'Estado', value: 'status', width: '10%' },
					{ text: 'Ref.', value: 'ref_order', width: '10%' },
				]
			}
		},
	},
	methods: {
		custom_sort: function (items, index, isDescending) {
			items.sort((a, b) => {
				if (isDescending) {
					return a[index] > b[index] ? 1 : -1
				} else {
					return b[index] > a[index] ? 1 : -1
				}
			})

			return items
		},
		date_range_select: async function (range) {
			if (this.startDate != range.startDate || this.endDate != range.endDate) {
				this.startDate = range.startDate
				this.endDate = range.endDate
			}
		},
		refresh: async function () {
			this.canRefresh = true

			await this.load_purchases_total()
			await this.load_purchases()
		},
		load_purchases_total: async function () {

			this.purchaseTotalLoading = true

			const baseQuery = this.build_base_query()
			const result = await this.get_transactions_total(
				this.affiliate._id,
				baseQuery
			)

			const dataPurchases =
				result && result.data && result.data[0] && result.data[0].purchases
			const dataReversals =
				result && result.data && result.data[0] && result.data[0].reversals


			var total = {
				issued: 0,
				approved: 0,
				cancelled: 0,
				denied: 0,
				denied_cancelled: 0,
				reversals: dataReversals || 0,
			}

			if (dataPurchases) {
				var contPurchases = dataPurchases.reduce(
					(acc, { _id, affiliate_commission }) => ({
						...acc,
						[_id]: affiliate_commission,
					}),
					{}
				)
				contPurchases.denied_cancelled =
					contPurchases.cancelled + contPurchases.denied
			}

			this.totalByStatus = {
				...total,
				...contPurchases,
			}

			this.purchaseTotalLoading = false

		},
		load_purchases: async function () {
			this.dataLoading = true
			let mgfKeysDetected = false
			let baseQuery = this.build_base_query()
			let query = {
				...baseQuery,
				start: this.pagination.page,
				limit: this.pagination.rowsPerPage,
				type: ['purchase', 'reversal'],
				sort_by: this.pagination.sortBy,
				sort_dir: this.pagination.descending ? 'desc' : 'asc',
			}

			const purchases = await this.get_transactions(this.affiliate._id, query)

			purchases.data.entries = purchases.data.entries.map((purchase) => {

				purchase.campaign_name = purchase.campaign.reg_name
				purchase.advertiser_name = purchase.advertiser.register.reg_name
				purchase.dtstring = new Date(purchase.datetime).toLocaleString()

				purchase.value_string = this.to_reais(+purchase.value)
				purchase.affiliate_commission_string = this.to_reais(
					+purchase.affiliate_commission
				)

				if (purchase.type === 'reversal') {
					purchase.status_string = 'Estornado'
				} else {
					const statusKey = this.statusDict.findIndex(
						({ id }) => id === purchase.status
					)
					let statusLabel = this.statusDict[statusKey].name
					purchase.status_string = statusLabel
				}

				if ('mgf_keys' in purchase) {
					mgfKeysDetected = true
				}

				return purchase

			})

			this.purchasesItems = purchases.data.entries

			this.totalPurchases = purchases.data.total

			this.includeMgfKeys = mgfKeysDetected

			this.dataLoading = false
		},
		fetch_all_purchases: async function () {
			this.dataLoading = true
			let mgfKeysDetected = false

			let baseQuery = this.build_base_query()
			let query = {
				...baseQuery,
				start: this.pagination.page,
				limit: this.totalPurchases,
				type: ['purchase', 'reversal'],
				sort_by: this.pagination.sortBy,
				sort_dir: this.pagination.descending ? 'desc' : 'asc',
			}

			const purchases = await this.get_transactions(this.affiliate._id, query)

			purchases.data.entries = purchases.data.entries.map((purchase) => {
				purchase.campaign_name = purchase.campaign.reg_name
				purchase.advertiser_name = purchase.advertiser.register.reg_name
				purchase.dtstring = new Date(purchase.datetime).toLocaleString()

				purchase.value_string = String(purchase.value.toFixed(2))
				purchase.affiliate_commission_string = String(purchase.affiliate_commission.toFixed(2))

				if (purchase.type === 'reversal') {
					purchase.status_string = 'Estornado'
				} else {
					const statusKey = this.statusDict.findIndex(
						({ id }) => id === purchase.status
					)
					let statusLabel = this.statusDict[statusKey].name
					purchase.status_string = statusLabel
				}

				if ('mgf_keys' in purchase) {
					mgfKeysDetected = true
				}
				return purchase
			})

			this.includeMgfKeys = mgfKeysDetected
			this.dataLoading = false

			return purchases.data.entries
		},
		add_thousands_sep(x) {
			var parts = x.toString().split(',')
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
			return parts.join(',')
		},
		build_base_query: function () {
			let query = {
				start_date: this.startDate.toISOString(),
				end_date: this.endDate.toISOString(),
			}

			if (this.selectedAdvertisers.length > 0) {
				query.advs = this.selectedAdvertisers.reduce(
					(acc, { _id }) => [...acc, _id],
					[]
				)
			}

			// Adiciona o filtro de Status APENAS se houver seleção
			if (Array.isArray(this.selectedStatus) && this.selectedStatus.length) {
				query.status = this.selectedStatus.reduce(
					(acc, { id }) => [...acc, id],
					[]
				)
			}

			return query
		},
		to_reais: function (value) {
			return 'R$ ' + this.add_thousands_sep(value.toFixed(2).replace('.', ','))
		},

	},
	watch: {
		startDate: function () {
			this.$root.period.startDate = this.startDate
		},
		endDate: function () {
			this.$root.period.endDate = this.endDate
		},
		selectedAdvertisers: async function () {
			this.$root.selectedAdvertisers = this.selectedAdvertisers
		},
		pagination: {
			async handler() {
				if (!this.canRefresh) return
				await this.load_purchases()
			},
			deep: true,
		},
	},
	created: async function () {
		if (
			this.$root.selectedAdvertisers &&
			this.$root.selectedAdvertisers.length
		) {
			this.selectedAdvertisers = this.$root.selectedAdvertisers
		}

		// --- NOVA CORREÇÃO (SINTAXE COMPATÍVEL) ---
		// Usamos '&&' para verificar se 'this.$root.period' existe
		// antes de tentar acessar 'startDate' ou 'endDate'.
		// Se a primeira parte (this.$root.period && ...) falhar (for 'falsy'),
		// ele usará o valor padrão (this.startDate).
		this.startDate = (this.$root.period && this.$root.period.startDate) || this.startDate
		this.endDate = (this.$root.period && this.$root.period.endDate) || this.endDate
		// --- FIM DA CORREÇÃO ---
	}
}

</script>

<style>
.div-component-header-purchases div#componente-header {
	position: absolute;
	z-index: 0;
	height: 0vh;
}

div.purchases {
	margin: 55px 10px 95px 10px;
}

.div-container-purchases .div-container-selects {
	margin-top: 25px;
	padding: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-container-purchases .div-container-selects .div-container-filters {
	width: 80%;
	margin-right: 20px;
}

/* Begin data select */

.div-container-purchases .div-container-selects .div-container-filters .v-input__prepend-outer {
	margin-top: 12px;
}

.div-container-purchases .div-container-selects .div-container-filters .v-input__slot {
	padding: 0 12px;
}

.div-container-purchases .div-container-selects .div-container-filters .v-input__slot .v-text-field__slot {
	padding-top: 5px;
}

.div-container-purchases .div-container-selects .div-container-filters .v-input__slot .v-label.v-label--active.theme--light {
	top: -2px;
	left: -3px !important;
}

.div-container-purchases .v-menu__activator .v-input.v-text-field.v-input--is-label-active.v-input--is-dirty.v-input--is-focused.v-input--is-readonly.theme--light.primary--text .v-input__prepend-outer i {
	color: #40DA99 !important;
}

.div-container-filters .v-input__icon.v-input__icon--prepend .v-icon.material-icons.theme--light {
	color: #40DA99 !important;
}

/* End data select */

/* Begin select anunciante */

.v-menu__content.theme--light.menuable__content__active {
	border-radius: 0px 0px 13px 13px !important;
}

.v-select-list.v-card.theme--light .v-list.theme--light {
	padding: 8px;
}

.div-container-purchases .div-container-selects .div-container-filters .v-input.v-text-field.v-select.v-input--is-label-active.v-input--is-dirty.theme--light {
	margin-top: 14px;
}

/* End select anunciante */

/* --- BOTÃO GERAR RELATÓRIO --- */

.div-container-purchases .div-container-filters-button button.button-generate-note {
	/* Base style */
	border-radius: 13px;
	margin-right: 10px;
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 12px;
	transform: opacity 0.2s;
}

/* Modo Escuro */
.theme--dark .div-container-purchases .div-container-filters-button button.button-generate-note {
	background: #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

/* Modo Claro */
.theme--light .div-container-purchases .div-container-filters-button button.button-generate-note {
	background: #FFFFFF;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.div-container-purchases .div-container-filters-button button.button-generate-note:hover {
	opacity: 0.5;
}

.div-container-purchases .div-container-filters-button button.button-generate-note:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}

.div-container-purchases .div-container-filters-button button.button-generate-note p {
	margin: 0px;
	font-size: 14px;
}

.div-container-purchases .div-container-filters-button button.button-generate-note .v-icon.material-icons-outlined.material-icons {
	margin-bottom: 5px;
	color: #40DA99 !important;
}

/* End botão gerara relatorio */

.div-container-card-purchases-one,
.div-container-card-purchases-two,
.div-container-card-purchases-three,
.div-container-card-purchases-four {
	border-radius: 13px;
	padding: 12px;
}

/* Modo Escuro */
.theme--dark .div-container-card-purchases-one,
.theme--dark .div-container-card-purchases-two,
.theme--dark .div-container-card-purchases-three,
.theme--dark .div-container-card-purchases-four {
	background: #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

/* Modo Claro */
.theme--light .div-container-card-purchases-one,
.theme--light .div-container-card-purchases-two,
.theme--light .div-container-card-purchases-three,
.theme--light .div-container-card-purchases-four {
	background: #FFFFFF;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

/* Layout e margens (Mantido o padrão) */
.div-container-card-purchases-one,
.div-container-card-purchases-two {
	margin-bottom: 13px;
	margin-top: 15px;
}

.div-container-card-purchases-one,
.div-container-card-purchases-three {
	margin-right: 13px;
	margin-left: 10px;
}

.div-container-card-purchases-two,
.div-container-card-purchases-four {
	margin-right: 23px;
}

.div-container-card-purchases-one p.paragrafo-title,
.div-container-card-purchases-two p.paragrafo-title,
.div-container-card-purchases-three p.paragrafo-title,
.div-container-card-purchases-four p.paragrafo-title {
	font-size: 16px;
	font-weight: 500;
	margin: 0px;
}


.div-container-card-purchases-one p.paragrafo-subtitle,
.div-container-card-purchases-two p.paragrafo-subtitle,
.div-container-card-purchases-three p.paragrafo-subtitle,
.div-container-card-purchases-four p.paragrafo-subtitle {
	font-size: 11px;
	margin: 0px 0px 5px 0px;
	opacity: 0.7;
}

.div-container-card-purchases-one p.paragrafo-value {
	font-size: 22px;
	margin: 0px;
	color: #40DA99 !important;
}

.div-container-card-purchases-two p.paragrafo-value {
	font-size: 22px;
	margin: 0px;
	color: #5191F2 !important;
}

.div-container-card-purchases-three p.paragrafo-value {
	font-size: 22px;
	margin: 0px;
	color: #EA4D4D !important;
}

.div-container-card-purchases-four p.paragrafo-value {
	font-size: 22px;
	margin: 0px;
	color: #F6851D !important;
}

/* End card show purchases */


/* --- TABELA DE DADOS --- */

.div-container-dataTable-purchases {
	margin-top: 35px;
	margin-right: 23px;
	margin-left: 10px;
}

/* Modo Escuro */
.theme--dark .div-container-dataTable-purchases .v-datatable.v-table {
	background: #2D2F32 !important;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 13px 13px 0px 0px;
}

.theme--dark .div-container-dataTable-purchases .v-datatable__actions {
	background: #2D2F32 !important;
}

.theme--dark .div-container-dataTable-purchases .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: rgba(0, 0, 0, 0.5);
}

/* Modo Claro */
.theme--light .div-container-dataTable-purchases .v-datatable.v-table {
	background: #FFFFFF !important;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
	border-radius: 13px 13px 0px 0px;
}

.theme--light .div-container-dataTable-purchases .v-datatable__actions {
	background: #FFFFFF !important;
}


.div-container-dataTable-purchases .v-datatable__actions .v-select__slot {
	padding: 0px 12px;
}

.v-select__slot .v-icon.material-icons.theme--light.primary--text {
	color: #40DA99 !important;
}

.div-container-dataTable-purchases .v-progress-linear .primary {
	background-color: #40DA99 !important;
}

/* End dataTable Purchases */

/* Begin circle loading */

.div-container-purchases .div-loading-circle {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 29.3vh;
}

.div-container-purchases .div-loading-circle circle.v-progress-circular__overlay {
	color: #40DA99 !important;
}

/* End circle loading */

@media (max-width: 961px) {
	.div-container-purchases {
		margin: auto !important;
		width: 100%;
	}
}

@media (max-width: 600px) {

	.div-container-card-purchases-one,
	.div-container-card-purchases-two,
	.div-container-card-purchases-three,
	.div-container-card-purchases-four {
		margin: 10px 22px 10px 10px;
	}
}
</style>
